/**
 * Pure marker/map helpers extracted verbatim from the legacy tracking +
 * visualization page entry files (§2 logic). Behavior is pinned by
 * characterization tests in markers.test.ts — do not "improve" without
 * re-pinning.
 */

/** Courier marker indicator color by active-order count + working state. */
export const getColor = (
  activeOrders?: unknown[] | null,
  isWorking?: boolean | null,
): string => {
  if ((activeOrders?.length ?? 0) > 1 && isWorking) return '#422AFB';
  if (activeOrders?.length && isWorking) return '#32CD32';
  if (isWorking) return '#FFD700';
  return '#FF4500';
};

/** Map zoom level from a lat/lng span, clamped to [5, 20]. */
export const calculateZoom = (latitudeRange: number, longitudeRange: number): number => {
  let zoom = 10;
  const maxZoom = 20;
  const minZoom = 5;
  if (latitudeRange > 0 || longitudeRange > 0) {
    const zoomFactor = Math.max(longitudeRange, latitudeRange);
    zoom = Math.log2(360 / zoomFactor);
  }
  return Math.min(Math.max(Math.floor(zoom), minZoom), maxZoom);
};
